import BasePerimeter from "./base";
import store from "../../store";

export default new BasePerimeter({
  purpose: "navigation",
  govern: {
    "can view": function() {
      return (
        this.isSuperAdmin() ||
        this.isAdmin() ||
        this.isClientAdmin() ||
        this.isAgencyAdmin() ||
        this.isAgencyUser()
      );
    },
    "can viewAgencies": function() {
      return this.isSuperAdmin() || this.isClientAdmin() || this.isAgencyAdmin() || this.isAdmin();
    },
    "can viewClients": function() {
      return this.isSuperAdmin() || this.isAdmin() || this.isClientAdmin();
    },
    "can viewUsers": function() {
      return this.isSuperAdmin() || this.isClientAdmin() || this.isAgencyAdmin() || this.isAdmin();
    },
    "can viewPackages": function() {
      return this.isSuperAdmin() || this.isAdmin();
    },
    "can viewCampaigns": function() {
      return this.isAgencyUser();
    },
    "can viewNotifications": function() {
      return this.isSuperAdmin() || this.isAdmin() || this.isClientAdmin() || this.isAgencyAdmin();
    },
    "can viewAllOrders": function() {
      return this.isSuperAdmin() || this.isAdmin() || this.isClientAdmin() || this.isAgencyAdmin();
    },
    "can viewAllReports": function() {
      return this.isSuperAdmin() || this.isAdmin();
    },
    "can viewSignifiLogs": function() {
      return this.isSuperAdmin() || this.isAdmin();
    },
    "can viewAdminFunctions": function() {
      return this.isSuperAdmin() || this.isAdmin();
    },
    "can accessAudienceFeatures": function() {
      const hasAudienceFeature = store.getters.getFeatures && store.getters.getFeatures.audience && store.getters.getFeatures.audience === true;

      return hasAudienceFeature;
    },
    "can useAdminTool": function() {
      const canUseAdminTool = store.getters.getAdminTools && store.getters.getAdminTools === true;

      return canUseAdminTool;
    },
  }
});
